import { DialogType } from '@tableau/widgets';
import React = require('react');
import { ModalInstance, ReactModalService } from '~commonInfra/dialogs/ReactModalService';
import { CommonStyles } from '~commonInfra/styles/CommonStyles';
import { Set } from '~commonInfra/utils/Set';

import { SetIntegrationUserSiteRoleDialog } from '../components/SetIntegrationUserSiteRoleDialog';
import { ISiteUserInfo } from '../users/models/ISiteUserInfo';

const SetIntegrationUserSiteRoleDialogStyle: React.CSSProperties = {
  width: 'auto',
  height: 'auto',
  paddingTop: CommonStyles.Sizes.MediumSpace,
  paddingLeft: CommonStyles.Sizes.MediumSpace,
  paddingRight: CommonStyles.Sizes.MediumSpace
};

function showSetIntegrationUserSiteRoleDialog(siteUsersToSet: Set<ISiteUserInfo>) {
  let modalInstance: ModalInstance<unknown>;
  const dialogProps = {
    close: () => modalInstance && modalInstance.close({}),
    dismiss: () => modalInstance && modalInstance.dismiss('cancel'),
    siteUsersToSet: siteUsersToSet
  };

  modalInstance = ReactModalService.open({
    type: DialogType.Uber,
    dialogContent: React.createElement(SetIntegrationUserSiteRoleDialog, dialogProps),
    testId: 'setIntegrationUserSiteRoleDialog',
    showCloseButton: true,
    dialogStyle: SetIntegrationUserSiteRoleDialogStyle,
    dialogBodyStyle: { overflow: 'hidden' },
    shouldNotSetDefaultWidth: true
  });
  return modalInstance.result;
}

export const SetIntegrationUserSiteRoleAction = {
  showSetIntegrationUserSiteRoleDialog
};
